// UserContext.js

import React from 'react';

const UserContext = React.createContext(null);

export default UserContext;
